import { useLoggingMutation } from 'lib/apollo/apollo-hooks';
import { UPSERT_ACTIVITY_OUTCOMES } from './activity-outcomes.graphql';
import type {
  UpsertActivityOutcomesMutation,
  UpsertActivityOutcomesMutationVariables,
} from './activity-outcomes.graphql.generated';

/**
 * Add activity outcomes to the Activity Builder JSON data.
 *
 * @returns The upsert activity outcomes function, loading state, and error state.
 */
const useUpsertActivityOutcomes = () => {
  const [upsertActivityOutcomes, { loading, error }] = useLoggingMutation<
    UpsertActivityOutcomesMutation,
    UpsertActivityOutcomesMutationVariables
  >(UPSERT_ACTIVITY_OUTCOMES);

  return {
    upsertActivityOutcomes,
    loading,
    error,
  };
};

export default useUpsertActivityOutcomes;
